'use client'

import NewsMaterialsTitle from '@/components/NewsMaterialsTitle'
import Header from '@/components/header/Header'
import Footer from '@/components/Footer/Footer'
import Filter from '@/components/filter/Filter'
import NewsCardList from '@/components/news/NewsCardList'
import { NewsItem, useFilterNewsMutation, useGetAllNewsQuery } from '@/redux/services/newsApi'
import NewsBanner from '@/components/news/NewsBanner'
import { useEffect, useState } from 'react'
import { RootState } from '@/redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { setResetCatalogFilters } from '@/redux/features/filterSlice'
import Calendar from '@/components/Calendar/Calendar'
import { getLang } from '@/helpers/getLang'

interface FilteredData {
    count: number,
    items: any[]
}

const mockData = [
    {
        title: 'ГК МЕГАМИКС на Агрос 2023',
        description:
            'МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.',
        tags: ['МегаМикс', 'Агрос', 'комбикорм', 'фермерам'],
        views: 13,
        preview:
            'https://genoservisrusko.com/wp-content/uploads/2023/08/megamix_logo_%D0%BF%D0%BE%D0%B4%D1%81%D1%82%D1%80%D0%BE%D1%87%D0%BD%D0%B8%D0%BA.ai-4-scaled.jpg',
        date: '05-10-2023'
    },
    {
        title: 'ГК МЕГАМИКС на Агрос 2023',
        description:
            'МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.',
        tags: ['МегаМикс', 'Агрос', 'комбикорм', 'фермерам'],
        views: 13,
        preview:
            'https://genoservisrusko.com/wp-content/uploads/2023/08/megamix_logo_%D0%BF%D0%BE%D0%B4%D1%81%D1%82%D1%80%D0%BE%D1%87%D0%BD%D0%B8%D0%BA.ai-4-scaled.jpg',
        date: '05-10-2023'
    },
    {
        title: 'ГК МЕГАМИКС на Агрос 2023',
        description:
            'МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.',
        tags: ['МегаМикс', 'Агрос', 'комбикорм', 'фермерам'],
        views: 13,
        preview:
            'https://genoservisrusko.com/wp-content/uploads/2023/08/megamix_logo_%D0%BF%D0%BE%D0%B4%D1%81%D1%82%D1%80%D0%BE%D1%87%D0%BD%D0%B8%D0%BA.ai-4-scaled.jpg',
        date: '05-10-2023'
    },
    {
        title: 'ГК МЕГАМИКС на Агрос 2023',
        description:
            'МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.',
        tags: ['МегаМикс', 'Агрос', 'комбикорм', 'фермерам'],
        views: 13,
        preview:
            'https://genoservisrusko.com/wp-content/uploads/2023/08/megamix_logo_%D0%BF%D0%BE%D0%B4%D1%81%D1%82%D1%80%D0%BE%D1%87%D0%BD%D0%B8%D0%BA.ai-4-scaled.jpg',
        date: '05-10-2023'
    },
    {
        title: 'ГК МЕГАМИКС на Агрос 2023',
        description:
            'МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.',
        tags: ['МегаМикс', 'Агрос', 'комбикорм', 'фермерам'],
        views: 13,
        preview:
            'https://genoservisrusko.com/wp-content/uploads/2023/08/megamix_logo_%D0%BF%D0%BE%D0%B4%D1%81%D1%82%D1%80%D0%BE%D1%87%D0%BD%D0%B8%D0%BA.ai-4-scaled.jpg',
        date: '05-10-2023'
    }
]

const selectList = ['Все годы', '2019', '2020', '2021']



const NewsModule = ({ data }: { data: NewsItem[] }) => {

    const [count, setCount] = useState(10)
    const [page, setPage] = useState(0)
    const [submitForm, filterResult] = useFilterNewsMutation()
    const [isFilterFilled, setIsFilterFilled] = useState(false)
    const [filteredData, setFilteredData] = useState<FilteredData>()
    const { newsSearch, newsFilterTags } = useSelector((state: RootState) => state.filter)
    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(setResetCatalogFilters())
    }, [])

    const filterBody = {
        get: count,
        page: page,
        ...(newsFilterTags && newsFilterTags.length && { tags: newsFilterTags }),
        ...(newsSearch && { title: newsSearch })
    }

    useEffect(() => {
        submitForm(filterBody).then((filterData: any) => {

            if (filterBody.tags || filterBody.title) {
                setIsFilterFilled(false)
            } else {
                setIsFilterFilled(true)
            }

            setFilteredData(filterData.data)
        })
    }, [newsSearch, newsFilterTags])

    return (
        <main style={{ background: '#f3f6fe' }}>
            <Header 
            isWhiteLogo={true}
            />
            <div className='news container'>
                <NewsMaterialsTitle />
                <NewsBanner />
                <Filter selectList={selectList} />
                {/* <NewsCardList buttonMore={false} /> */}
            </div>
            {filteredData?.items?.length ? <NewsCardList
                count={count}
                setCount={(num) => setCount(num)}
                data={filteredData.items}
                totalCount={filteredData.count}
                buttonMore={true} />
                :
                <div className="container">
                    <ul
                        style={{ display: 'flex' }}
                        className='news__card-list'
                    >
                        <h2 style={{ margin: '200px 0' }} className='catalog__nothing-found'>Статей по Вашему запросу не найдено</h2>
                    </ul>
                </div>
            }
            <Footer mapTheme='light'/>
        </main>
    )
}

export default NewsModule
